module.exports = __webpack_public_path__ + "static/media/make.69d784c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/make.png
// module id = 81
// module chunks = 0